import { Heart } from "lucide-react";
import { useWishlist } from "@/context/WishlistContext";

export const HeartButton = ({ id, className = "" }) => {
  const { has, toggle } = useWishlist();
  const on = has(id);
  return (
    <button
      data-testid={`wishlist-toggle-${id}`}
      data-active={on ? "true" : "false"}
      aria-label={on ? "Rimuovi dai preferiti" : "Aggiungi ai preferiti"}
      aria-pressed={on}
      onClick={() => toggle(id)}
      className={`grid place-items-center rounded-full border-2 border-[#0b0b0f] bg-white transition-transform duration-150 hover:scale-105 active:scale-95 ${className}`}
    >
      <Heart className={`h-4 w-4 ${on ? "fill-[#ff2e63] text-[#ff2e63]" : ""}`} />
    </button>
  );
};
